<template lang="html">
    <div>
        <Card>
            <template v-slot:head>
                <h5>
                    Submission Checklist <span style="color:red; font-size:16px;  margin:0;">*</span>
                </h5>
            </template>
            <template v-slot:main>
                <p>
                    <strong>
                        Please acknowledge that you have read and understand the following important items before proceeding with submitting your manuscript.
                    </strong>
                </p>
                <check-list
                    v-bind:items="items"
                    v-bind:label-key="'content'"></check-list>
            </template>
        </Card>
    </div>
</template>

<script>
export default {
    props: [
        "items"
    ],
    methods: {
        async getItems() {
            try {
                let result = await axios.get('/api/submission-checklist');

                this.items = result.data;

                for (let item of this.items) {
                    item.content = item.content.substring(3, item.content.length - 4);
                }

            } catch (exception) {

            }
        }
    },
    created() {
        if (!this.items) {
            this.getItems();
        }
    }
}
</script>

<style lang="css" scoped>
</style>
